import { render } from "./TheProfessionalInterConsultationUpdate.vue?vue&type=template&id=266369c2&scoped=true&ts=true"
import script from "./TheProfessionalInterConsultationUpdate.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalInterConsultationUpdate.vue?vue&type=script&lang=ts"

import "./TheProfessionalInterConsultationUpdate.vue?vue&type=style&index=0&id=266369c2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266369c2"]])

export default __exports__